import Repository from "./Repository";

export default {
  // Get All Dealer Companies
  getDealerCompanies() {
    return Repository.get(`/admin/dealer_company`);
  },

  getDealerCompany(id) {
    return Repository.get(`/admin/dealer_company/${id}`);
  },

  createDealerCompany(payload) {
    return Repository.post(`/admin/dealer_company`, payload);
  },

  updateDealerCompany(payload) {
    const id = payload.id;
    delete payload.id;
    return Repository.put(`/admin/dealer_company/${id}`, payload);
  },

  deleteDealerCompany(id) {
    return Repository.delete(`/admin/dealer_company/${id}`);
  },

  getDealersByCompany(id) {
    return Repository.get(`/admin/dealer_company/${id}/dealer`);
  },

  getCompanyDealer(payload) {
    return Repository.get(
      `/admin/dealer_company/${payload.id}/dealer/${payload.email}`
    );
  },

  updateDealer(payload) {
    const email = payload.email;
    const companyId = payload.companyId;

    delete payload.email;
    delete payload.companyId;

    return Repository.put(
      `/admin/dealer_company/${companyId}/dealer/${email}`,
      payload
    );
  },

  deleteDealer(payload) {
    return Repository.delete(
      `/admin/dealer_company/${payload.id}/dealer/${payload.email}`
    );
  },

  inviteDealer(payload) {
    const id = payload.id;
    delete payload.id;
    return Repository.post(
      `/admin/dealer_company/${id}/dealer/invite`,
      payload
    );
  }
};
